module.exports = __webpack_public_path__ + "media/images/icons/clock-38d2912fc30953d30fdf5177d4e776ff.svg";